import WithdrawHistoryDialog from './WithdrawHistoryDialog';

export default WithdrawHistoryDialog;
